/* eslint-disable prefer-regex-literals */
/* eslint-disable no-restricted-globals */
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import i18next from 'i18next';
import i18n from '../locales';
import { resolveSupportedLocale } from '../locales/localeConfig';

export const formatDate = (value, _format = 'MM/dd/yyyy') => {
	try {
		let formattedValue = value;
		if (typeof value === 'string') {
			formattedValue = value.trim().replace(/\s/, 'T');
		}
		if (value) {
			const d = Date.parse(formattedValue);
			return isValid(d) ? format(d, _format) : '';
		}

		return '';
	} catch (e) {
		console.error(e);
		return '';
	}
};

export const formatTime = (value, _format = 'hh:mm a') =>
	formatDate(value, _format);

export const formatDateTime = (value, _format = 'MM/dd/yy hh:mm a') =>
	formatDate(value, _format);

export const makeKey = (obj) =>
	btoa(unescape(encodeURIComponent(JSON.stringify(obj))));

export const locales = () => resolveSupportedLocale(i18n.language);

export const timezone = () => {
	const zone = new Intl.DateTimeFormat(locales(), { timeZoneName: 'short' })
		.formatToParts(new Date())
		.find((part) => part.type === 'timeZoneName').value;
	return zone;
};

export const newDate = (value) => {
	const date = new Date(value).toLocaleDateString(locales());
	return date;
};

export const shipmentStatusLang = (value) => {
	const lang = i18next.t(`shipment_status:${value}`);
	if (value && (value !== null || undefined)) {
		return lang;
	}
	return '';
};

// check is format is YYYY-MM-DDTHH:MN:SS.MSSZ
function isIsoDate(str) {
	if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
	const d = new Date(str);
	return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str; // valid date
}

export const isValidDateTime = (str) => {
	// DateTime(YYYY-MM-DD HH:MM:SS)
	const regex = new RegExp(
		/^([0-9]{4})-((01|02|03|04|05|06|07|08|09|10|11|12|(?:J(anuary|u(ne|ly))|February|Ma(rch|y)|A(pril|ugust)|(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)|(JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)|(September|October|November|December)|(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)))|(january|february|march|april|may|june|july|august|september|october|november|december))-([0-3][0-9])\s([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9])$/
	);
	if (str === null) {
		return 'false';
	}
	if (regex.test(str) === true) {
		return 'true';
	} else {
		return 'false';
	}
};

export function isValidDate(str) {
	// Date(YYYY-MM-DD)
	const regEx = /^\d{4}-\d{2}-\d{2}$/;
	if (!str.match(regEx)) return false;
	const d = new Date(str);
	const dNum = d.getTime();
	if (!dNum && dNum !== 0) return false;
	return d.toISOString().slice(0, 10) === str;
}

// time ex 11:21 PM EDT, EST
export const newTimeTz = (value) => {
	const date = new Date(value);
	const time = date
		.toLocaleTimeString(locales(), { hour12: true })
		.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3');
	return `${time} ${timezone()}`;
};

// time ex 11:21 PM EDT, EST
export const newTimeUTCAddTz = (value) => {
	const date = new Date(`${value}Z`);
	const time = date
		.toLocaleTimeString(locales(), { hour12: true })
		.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3');
	return `${time} ${timezone()}`;
};

// date, time & timezone ex 11/09/2021 11:21 PM EDT
export const dateTimeTz = (value) => {
	const date = new Date(`${value}`)
		.toLocaleString(locales(), { hour12: true })
		.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3');
	return `${date} ${timezone()}`;
};

// date, time & timezone ex 11/09/2021 11:21 PM EDT with no TimeZone
export const dateTimeTzNoZ = (value) => {
	const date = new Date(`${value}Z`)
		.toLocaleString(locales(), { hour12: true })
		.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3');
	return `${date} ${timezone()}`;
};

// date, time YYYY-MM-DDTHH:MN:SS.MSS (ISO 8601) to UTC to date, time and timezone 11/09/2021 11:21 PM EST
export const dateTimeISO = (value) => {
	const dateISO = new Date(new Date(`${value}`).toUTCString());
	const date = new Date(`${dateISO}`)
		.toLocaleString(locales(), { hour12: true })
		.replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3');
	return `${date} ${timezone()}`;
};
